/* 15th Anniversary — Storytellers carousel
   Figma: PC 1650:2843 / M 1650:3718 */
(function () {
  function initStorytellers(root) {
    if (!root || root.dataset.storytellersInit === 'true') return;
    root.dataset.storytellersInit = 'true';

    if (typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.storytellers__swiper');
    if (!swiperEl) return;

    var slides = root.querySelectorAll('.storytellers__slide');
    var groupSize = root.querySelectorAll('.storytellers__slide[data-story-copy="2"]').length || slides.length;
    var total = groupSize;
    if (total === 0) return;

    var enableLoop = total > 1;
    var autoplay = root.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(root.dataset.autoplayDelay, 10);
    if (!Number.isFinite(autoplayDelay) || autoplayDelay <= 0) {
      autoplayDelay = 5;
    }

    /*
      The Liquid template renders the story blocks THREE times
      (data-story-copy 1 / 2 / 3). We therefore drive a bounded track
      (`loop:false`) and treat the middle copy as home. When the active slide
      drifts out of the middle group we teleport the track by one whole group —
      instantly and off-screen — so the visible transition is always a single
      animated card slide.

      This replaces Swiper's own `loop`, which could not animate the wrap here:
      `loopedSlides` was clamped to the slide count so no clone sat ahead of
      the active slide, and the wrap fell back to an instant reposition
      (measured ~1422px, three cards => "last slide jumps back to first").

      We verified on the live page that none of these fix Swiper's loop either:
        - pinning loopedSlides / loopAdditionalSlides (clamped by Swiper)
        - removing our slideChangeTransitionEnd update()
        - slidesPerView: 3 instead of 'auto' (loopedSlides becomes 3, worse)
        - rewind instead of loop (same instant reposition on wrap)
    */
    /*
      Index of the first slide of the middle copy.

      The emulated loop re-centres whenever the active slide has no real
      neighbour left inside the middle copy. Keep one slide of headroom on each
      side, so the valid resting window is [groupSize + 1, groupSize * 2 - 2].
      Starting exactly on the first slide of the middle copy (groupSize) sits one
      outside that window, so the very first settle would nudge the track; start
      one inside instead and the initial position is already stable.
    */
    var HOME_SAFE = enableLoop ? Math.min(groupSize + 1, groupSize * 2 - 2) : 0;

    var options = {
      slidesPerView: 'auto',
      // Bounded track: the wrap is emulated by re-centring to the middle copy
      // (see the loopFix emulation in the click handler below).
      loop: false,
      // Desktop (Figma 1650:2843): the active card is centred, so both the
      // previous and the next card peek in from the sides.
      centeredSlides: true,
      initialSlide: HOME_SAFE,
      speed: 450,
      spaceBetween: 24,
      grabCursor: true,
      watchOverflow: true,
      resizeObserver: true,
      observeParents: true,
      // A drag must settle on the nearest card. shortSwipes keeps a small
      // flick from being left between two cards.
      shortSwipes: true,
      longSwipesRatio: 0.3,
      threshold: 5,
      navigation: {
        nextEl: root.querySelector('.storytellers__nav--next'),
        prevEl: root.querySelector('.storytellers__nav--prev'),
      },
      // Mobile (Figma 1650:3718): the active card is flush with the left edge
      // of the carousel and only the next card peeks on the right. Desktop
      // keeps the active card centred. Either way a swipe locks to that
      // resting slot instead of stopping between cards.
      breakpoints: {
        0: {
          centeredSlides: false,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          spaceBetween: 16,
        },
        769: {
          centeredSlides: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          spaceBetween: 24,
        },
      },
    };

    if (autoplay) {
      options.autoplay = {
        delay: autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    // 切换按钮埋点：image_switch（module=UGC）
    // icon_location=Left/Right，position=切换到位后的卡片位置
    var pendingNavDirection = '';

    function trackImageSwitch(iconLocation, position) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'image_switch',
        event_parameters: {
          icon_location: iconLocation,
          position: position,
          module: 'UGC',
        },
      });
    }

    /*
      Emulated loop.

      The track holds three identical copies of the slides (see the Liquid
      section) and `loop:false` drives it directly, starting on the middle copy.

      After every settled transition we re-centre the track by one whole group
      whenever the active slide has drifted out of the middle copy, so there is
      always a real card on both sides of the centred one and the wrap is an
      ordinary single-position animation. The three copies render the exact same
      image/name, so that reposition is invisible.

      Three things had to be true for this to stop flickering ("闪动" — a
      one-frame white flash plus a card size/position jump at the wrap):

      1. The move must not go through Swiper's `update()`.
         `sw.setTransition(0); sw.slideTo(idx, 0, false);` still runs
         `updateActiveIndex -> updateSlidesClasses -> update`, and with
         `slidesPerView: 'auto'` + `centeredSlides` that last `update` recomputes
         `translate` from the *current* scroll position. It therefore painted the
         new active card while the transform still described the previous slot
         layout, and only corrected it on the following frame. We now shift the
         wrapper's translate by exactly the distance between the two slot offsets
         and sync the classes ourselves, so the active index and the transform
         always land together, in one frame.

      2. The card size must not be part of the slide's layout box.
         The card we land on was a peeking side card a moment ago. If the slide
         itself changed width (500px <-> 450px) on active/inactive, every class
         swap re-laid-out the whole track: Swiper writes `translate` for the old
         widths, the widths then change, and for one frame every card is drawn at
         the wrong offset before the transform animates to catch up — which read
         as the previous/next cards jumping and flashing. The slide is now a
         fixed-size slot and the active/inactive difference is a `scale` on the
         inner `.storytellers__card`, so `translate` stays valid across a class
         swap and only the inner card animates.

      3. The teleport must not invalidate the composited tiles.
         Moving the track ~1896px in a single frame used to force the compositor
         to re-rasterise every large card image, showing a one-frame blank/stale
         tile. The wrapper and slides are now promoted to their own layers in CSS
         (`will-change: transform` / `backface-visibility: hidden`), so the layer
         is simply moved and the teleport is genuinely off-screen.

      Takes the swiper instance as a parameter: the handlers below are defined
      before `swiper` exists (they are passed to the constructor), so they must
      use the emitter's `this` rather than closing over `swiper`.
    */
    function normaliseLoopPosition(sw) {
      if (!enableLoop || !sw || !sw.wrapperEl || !sw.slidesGrid) return;
      var active = sw.activeIndex;
      var groupStart = groupSize;             // first index of middle copy
      var groupEnd = groupSize * 2 - 1;       // last index of middle copy

      // Keep a one-slide buffer inside the middle copy so the next step in
      // either direction still has a real slide to move onto.
      var safeStart = groupStart + 1;
      var safeEnd = groupEnd - 1;

      var target = null;
      if (active < safeStart) {
        target = active + groupSize;
      } else if (active > safeEnd) {
        target = active - groupSize;
      }
      if (target === null || target === active) return;

      var startOffset = sw.slidesGrid[active];
      var endOffset = sw.slidesGrid[target];
      if (typeof startOffset !== 'number' || typeof endOffset !== 'number') return;
      var delta = endOffset - startOffset;

      var wrapper = sw.wrapperEl;
      // Freeze the track and the card scale for the reposition. The card we
      // land on was a side card (scale 0.9). If that scale is allowed to
      // transition, the centred card visibly shrinks to 450px and grows back
      // — the current-item flash. With the transition off, it is already at
      // scale 1 on the frame the track jumps.
      wrapper.style.transition = 'none';
      var fits = wrapper.querySelectorAll('.storytellers__fit');
      for (var i = 0; i < fits.length; i += 1) {
        fits[i].style.transition = 'none';
      }

      sw.setTransition(0);
      sw.setTranslate(sw.translate - delta);
      sw.activeIndex = target;
      sw.updateSlidesClasses();
      sw.updateProgress(sw.translate);

      void wrapper.offsetWidth;

      wrapper.style.removeProperty('transition');
      sw.setTransition(sw.params.speed);
      // Restore the scale transition only after this snap has been painted,
      // otherwise the browser animates 0.9 -> 1 on the card we just landed on.
      window.requestAnimationFrame(function () {
        for (var j = 0; j < fits.length; j += 1) {
          fits[j].style.removeProperty('transition');
        }
      });
    }

    // Map a slide element to the user-facing story index (0..groupSize-1).
    function storyIndexOfSlide(sw, slide) {
      if (!sw || !slide) return -1;
      var idx = Array.prototype.indexOf.call(sw.slides, slide);
      if (idx < 0) return -1;
      return ((idx % groupSize) + groupSize) % groupSize;
    }

    options.on = {
      slideChangeTransitionEnd: function () {
        normaliseLoopPosition(this);

        if (!pendingNavDirection) return;
        var direction = pendingNavDirection;
        pendingNavDirection = '';
        trackImageSwitch(direction, storyIndexOfSlide(this, this.slides[this.activeIndex]) + 1);
      },
    };

    var swiper = new Swiper(swiperEl, options);

    // Swiper snaps on release, but a fast flick can leave `translate` between
    // two snap points. Once the gesture is over and nothing is animating,
    // pull the track onto the nearest resting slot (left edge on mobile,
    // centred card on desktop).
    swiper.on('touchEnd', function () {
      window.setTimeout(function () {
        if (!swiper || swiper.destroyed || swiper.animating) return;
        var snap = swiper.snapGrid && swiper.snapGrid[swiper.activeIndex];
        if (typeof snap !== 'number') return;
        // snapGrid is a positive offset; translate is the negative of it.
        if (Math.abs(swiper.translate + snap) > 1) {
          swiper.slideToClosest(swiper.params.speed);
        }
      }, 0);
    });

    var prevBtn = root.querySelector('.storytellers__nav--prev');
    var nextBtn = root.querySelector('.storytellers__nav--next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pendingNavDirection = 'Left';
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pendingNavDirection = 'Right';
      });
    }

    /*
      Clicking a peeking side card advances the carousel by one step in that
      direction; clicking the centred card opens its story popup.

      We step with slideNext()/slidePrev() (not slideTo(idx)) so the wrap from
      the last story to the first is a normal one-position animation; the
      teleport that makes it look infinite happens invisibly in
      normaliseLoopPosition() once the transition settles.
    */
    var clickToggle = root.querySelector('.storytellers__swiper');
    if (clickToggle) {
      clickToggle.addEventListener('click', function (e) {
        // A swipe ends with a click on whatever card is under the finger.
        // Stepping again here fights the snap and leaves the track off-centre.
        if (swiper.allowClick === false || swiper.animating) return;
        var slide = e.target.closest('.storytellers__slide');
        if (!slide) return;
        // Let the active card's popup overlay handle its own click.
        if (e.target.closest('[data-story-modal-open]')) return;
        if (slide.classList.contains('swiper-slide-active')) return;

        // Which side of the centred card was tapped?
        var card = slide.getBoundingClientRect();
        var centre = swiperEl.getBoundingClientRect().left + swiperEl.clientWidth / 2;
        var tappedCentre = card.left + card.width / 2;
        var forward = tappedCentre > centre;

        if (forward) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
      });
    }

    root.__storytellersSwiper = swiper;
  }

  /* ---- Story popup modal ---- */
  var DIALOG_W = 1200;
  var DIALOG_H = 680;
  var DIALOG_GUTTER = 32;

  /* The dialog is a fixed 1200x680 design with fixed-pixel offsets inside, so we
     scale the whole thing to fit rather than letting it reflow. Only applies on
     desktop; the <=768px layout is fully responsive and must not be scaled. */
  function fitDialogs() {
    document.querySelectorAll('[data-story-modal]').forEach(function (modal) {
      if (window.innerWidth <= 768) {
        modal.style.removeProperty('--st-dialog-scale');
        return;
      }
      var availableW = window.innerWidth - DIALOG_GUTTER;
      var availableH = window.innerHeight - DIALOG_GUTTER;
      var scale = Math.min(availableW / DIALOG_W, availableH / DIALOG_H, 1);
      if (!Number.isFinite(scale) || scale <= 0) scale = 1;
      modal.style.setProperty('--st-dialog-scale', String(scale));
    });
  }

  function initStoryModal(root) {
    var openers = root.querySelectorAll('[data-story-modal-open]');
    if (!openers.length) return;

    var lastFocused = null;

    function getModal(id) {
      return root.querySelector('[data-story-modal="' + id + '"]');
    }

    fitDialogs();

    function syncScrollbar(modal) {
      var scroll = modal.querySelector('[data-story-modal-scroll]');
      var bar = modal.querySelector('[data-story-modal-scrollbar]');
      var thumb = modal.querySelector('[data-story-modal-thumb]');
      if (!scroll || !bar || !thumb) return;

      var scrollable = scroll.scrollHeight - scroll.clientHeight;
      if (scrollable <= 1) {
        bar.classList.remove('is-active');
        return;
      }
      bar.classList.add('is-active');

      var track = bar.clientHeight;
      var thumbH = Math.max((scroll.clientHeight / scroll.scrollHeight) * track, 32);
      var maxTop = track - thumbH;
      var ratio = scroll.scrollTop / scrollable;
      thumb.style.height = thumbH + 'px';
      thumb.style.transform = 'translateY(' + (ratio * maxTop) + 'px)';
    }

    function openModal(modal) {
      lastFocused = document.activeElement;
      modal.hidden = false;
      fitDialogs();
      // force reflow so the transition plays
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('storytellers-modal-open');

      var scroll = modal.querySelector('[data-story-modal-scroll]');
      if (scroll) scroll.scrollTop = 0;
      syncScrollbar(modal);

      var closeBtn = modal.querySelector('.storytellers__dialog-close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal(modal) {
      modal.classList.remove('is-open');
      document.body.classList.remove('storytellers-modal-open');
      window.setTimeout(function () {
        modal.hidden = true;
      }, 250);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    // 点击展示用户故事长文卡片埋点：select_content（content_type=UGC, content_name=Brand_Day）
    // button_name = 图片一级标题（storyteller 名字）
    function trackSelectContent(button) {
      var card = button.closest('.storytellers__card');
      var nameEl = card && card.querySelector('.storytellers__name');
      var buttonName = nameEl ? nameEl.textContent.trim() : '';
      if (!buttonName) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'select_content',
        event_parameters: {
          content_type: 'UGC',
          content_name: 'Brand_Day',
          button_name: buttonName,
        },
      });
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        /*
          Only the centred (active) card opens the popup. Clicking a peeking
          side card steps the carousel instead, so ignore taps on any other
          slide, and ignore taps while a transition is running (the tap starts
          the slide change immediately, so the class check alone is racy).
        */
        var swiper = root.__storytellersSwiper;
        if (swiper && swiper.animating) return;

        var slide = btn.closest('.storytellers__slide');
        if (!slide) return;
        if (!slide.classList.contains('swiper-slide-active')) return;
        // Any centred copy can open its popup. The three copies render the same
        // story, so the copy that happens to sit in the middle after a jump is
        // not restricted to the middle group.
        var modal = getModal(btn.dataset.storyModalOpen);
        if (!modal) return;
        trackSelectContent(btn);
        openModal(modal);
      });
    });

    root.querySelectorAll('[data-story-modal]').forEach(function (modal) {
      modal.querySelectorAll('[data-story-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeModal(modal);
        });
      });

      var scroll = modal.querySelector('[data-story-modal-scroll]');
      if (scroll) {
        scroll.addEventListener('scroll', function () {
          syncScrollbar(modal);
        });
      }

      var bar = modal.querySelector('[data-story-modal-scrollbar]');
      var thumb = modal.querySelector('[data-story-modal-thumb]');
      if (bar && thumb && scroll) {
        var dragging = false;
        var startY = 0;
        var startTop = 0;

        function onMove(e) {
          if (!dragging) return;
          var track = bar.clientHeight;
          var thumbH = thumb.offsetHeight;
          var maxTop = track - thumbH;
          if (maxTop <= 0) return;
          var delta = ((e.touches ? e.touches[0].clientY : e.clientY) - startY);
          var nextTop = Math.min(Math.max(startTop + delta, 0), maxTop);
          var scrollable = scroll.scrollHeight - scroll.clientHeight;
          scroll.scrollTop = (nextTop / maxTop) * scrollable;
          e.preventDefault();
        }

        function onUp() {
          dragging = false;
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('touchend', onUp);
        }

        function onDown(e) {
          dragging = true;
          var rect = thumb.getBoundingClientRect();
          startY = (e.touches ? e.touches[0].clientY : e.clientY);
          startTop = rect.top - bar.getBoundingClientRect().top;
          document.addEventListener('mousemove', onMove);
          document.addEventListener('mouseup', onUp);
          document.addEventListener('touchmove', onMove, { passive: false });
          document.addEventListener('touchend', onUp);
          e.preventDefault();
        }

        thumb.addEventListener('mousedown', onDown);
        thumb.addEventListener('touchstart', onDown, { passive: false });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      root.querySelectorAll('[data-story-modal].is-open').forEach(function (modal) {
        closeModal(modal);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-storytellers]').forEach(function (root) {
      initStorytellers(root);
      initStoryModal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  fitDialogs();

  var resizeRaf = null;
  window.addEventListener('resize', function () {
    if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
    resizeRaf = window.requestAnimationFrame(function () {
      resizeRaf = null;
      fitDialogs();
    });
  });

  window.addEventListener('orientationchange', fitDialogs);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-storytellers]');
    if (section) {
      section.dataset.storytellersInit = 'false';
      initStorytellers(section);
      initStoryModal(section);
    }
  });
})();
